module.exports = __webpack_public_path__ + "img/Settings.342e26f4.svg";